// extracted by mini-css-extract-plugin
export var carrierNotice = "_ld-5";
export var carrierNoticePlaceholder = "_ld-6";
export var deliveryRow = "_ld-c";
export var fixedHeight = "_ld-4";
export var freightLogo = "_ld-b";
export var fullWidth = "_ld-3";
export var priceColumn = "_ld-7";
export var radioSelected = "_ld-9";
export var radioUnselected = "_ld-8";
export var selectedOption = "_ld-2";
export var selectedOptionContainer = "_ld-1";
export var selection = "_ld-0";
export var tallSkeletonText = "_ld-a";